import { BaseTravelSegment } from "../../../shared/types/travelSegment";

const identifierListFromTravelSegment = (travelSegment: BaseTravelSegment) => {
	switch (travelSegment.type) {
		case "car":
		case "shuttle":
			return [travelSegment.identifier];
		case "train":
		case "flight":
			return [travelSegment.identifier, ...travelSegment.additionalIdentifiers];
	}
};

export const travelSegmentIdentifier = (travelSegment: BaseTravelSegment) => {
	return identifierListFromTravelSegment(travelSegment).filter(Boolean).join("/") || "-";
};
